import { child, runTransaction } from "firebase/database";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { buildDriverArrivingPush, driverArrivingCheck } from '../other/driverArriving';

/** Reservas ya intentadas en esta sesión: el GPS llega cada pocos segundos y la reserva tarda en reflejar la marca. */
const attempted = new Set();
const PUSH_RETRY_MS = 4000;

/**
 * Llamada por la app del conductor en cada GPS. La transacción sobre `driverArrivingAt` garantiza un solo
 * push por viaje aunque el conductor tenga dos teléfonos o el GPS cruce el umbral varias veces.
 */
export const notifyDriverArrivingIfNear = async (booking, location) => {
  if (!booking || !booking.id || attempted.has(booking.id)) return null;
  const check = driverArrivingCheck(booking, location);
  if (!check.notify) return null;
  attempted.add(booking.id);

  const { singleBookingRef } = firebase;
  const now = Date.now();
  let committed = false;
  try {
    const result = await runTransaction(child(singleBookingRef(booking.id), 'driverArrivingAt'), (current) => {
      if (current) return undefined;
      return now;
    });
    committed = !!(result && result.committed && result.snapshot.val() === now);
  } catch (error) {
    // Sin red: se reintenta con el siguiente GPS.
    attempted.delete(booking.id);
    console.warn('[driverArriving] marca no guardada', booking.id, error && error.message);
    return { ...check, sent: false };
  }
  if (!committed) return { ...check, sent: false };

  const L = store.getState().languagedata.defaultLanguage || {};
  const payload = buildDriverArrivingPush(booking, {
    title: L.driver_arriving_title,
    msg: L.driver_arriving_msg,
  });
  let response = await RequestPushMsg(booking.customer_token, payload, booking.customer);
  // La marca ya quedó guardada (no habrá otro intento): un fallo de red en el envío se reintenta una vez.
  if (!response || response.error) {
    await new Promise((resolve) => setTimeout(resolve, PUSH_RETRY_MS));
    response = await RequestPushMsg(booking.customer_token, payload, booking.customer);
  }
  return { ...check, sent: !!(response && !response.error) };
};
